module.exports = __webpack_public_path__ + "media/images/austria-flag-round-acdcfa25418c77aea46a31c50e3ab9d0.png";